import { processResponse, processError } from './auth';
import { API_NAME } from '../config';

const postExchange = (body, headers) => {
  return fetch(process.env.GATSBY_BASE_URL + `${API_NAME}/exchange/`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
    .then((response) => {
      return processResponse(response);
    })
    .catch((err) => {
      processError(err, 'postExchange');
    });
};

export { postExchange };
